export const START_PROFIT_WELL = "START_PROFIT_WELL";

export const LOGOUT = "LOGOUT";